import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import nativeAmericanTwoTrainersData from '../data/NativeAmericanTwo';
import './NativeAmericanTwo.css';

const NativeAmericanTwoTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(nativeAmericanTwoTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('🏜️ Native American Two trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/native-american-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/native-american-train-categories');
    };

    return (
        <div className="native-trainers-container">
            <div className="native-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="native-trainers-header">
                <div className="header-content">
                    <h1>Desert & Mountain Warriors</h1>
                    <p>Train with legendary Apache and Comanche desert fighters</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Southwest Nations</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="native-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="native-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--native-primary-color': trainer.color,
                            '--native-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="native-trainer-image-section">
                            <div
                                className="native-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="native-spirit-effect"></div>
                                <div className="experience-badge native-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="native-trainer-info-section">
                            <h3 className="native-trainer-name">{trainer.name}</h3>
                            <p className="native-trainer-specialization">{trainer.specialization}</p>
                            <p className="native-trainer-description">{trainer.intro}</p>

                            <div className="native-trainer-details">
                                <div className="detail-item native-detail">
                                    <div className="detail-icon">🌵</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item native-detail">
                                    <div className="detail-icon">🏔️</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="native-trainers-footer">
                <div className="native-info">
                    <h3>Desert & Mountain Warriors Philosophy</h3>
                    <div className="native-benefits-grid">
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🏜️</div>
                            <div>
                                <strong>Desert Lightning</strong>
                                <p>Explosive speed and elusive movement perfected in harsh environments</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🦬</div>
                            <div>
                                <strong>Sacred Buffalo Power</strong>
                                <p>Traditional Comanche strength wrapped in spiritual connection</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">⛰️</div>
                            <div>
                                <strong>Mountain Fortress</strong>
                                <p>Tactical intelligence and commanding presence from high ground</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🌪️</div>
                            <div>
                                <strong>Guerrilla Mastery</strong>
                                <p>Hit-and-run tactics with hypervigilant conditioning</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NativeAmericanTwoTrainers;